import React, { useState, useEffect } from "react";
import { Form, Nav, Tab } from "react-bootstrap";
import useMessage from "hooks/useMessage";
import { CompaniaManager } from "managers";
import { useAuthentication, useApp } from "hooks";
import useExceptionHandler from "hooks/useExceptionHandler";
import EditHeader from "components/PantallasEdit/Header/EditHeader";
import { ConfiguracionEmailHelper, TIPO_SISTEMA_EXTERNO } from "utils";
import { ConfiguracionCorreoElectronicoManager } from "managers";
import { SvgComponent } from "components";

import InformacionCompaniaTab from "./tabs/InformacionCompaniaTab";
import RepresentacionImpresaTab from "./tabs/RepresentacionImpresaTab";
import ComprobantesElectronicosTab from "./tabs/ComprobantesElectronicosTab";
import ServidorCorreoTab from "./tabs/ServidorCorreoTab";
import OtrasConfiguracionesTab from "./tabs/OtrasConfiguracionesTab";

export default function ConfigurarCompania({
  showLoading,
  hideLoading,
  isActive,
}) {
  const [compania, setCompania] = useState({
    IncluirITBISDetalles: false,
    MostrarValorPagar: false,
    IncluirSubTotalesInformativos: false,
    UsaAlertarFinSerie: false,
  });
  const [tipoActual, setTipoActual] = useState();
  const [configuracionEmail, setConfiguracionEmail] = useState({});
  const [configuracionSistemaExterno, setconfiguracionSistemaExterno] = useState({});
  const [currentTab, setCurrentTab] = useState("info-compania");
  const { configuration } = useApp();
  const { usuario } = useAuthentication();
  const { Message, cerrarAlertas } = useMessage();
  const { handleException } = useExceptionHandler();

  const AMBIENTE_LIST = [
    { value: "T", label: "Prueba" },
    { value: "C", label: "Certificación" },
    { value: "S", label: "Simulación" },
  ];

  const iconStyle = { marginRight: "15px" };
  const iconColor = "#3f3f3f";
  const navStyle = { width: "100%", justifyContent: "center" };
  const paneStyle = { padding: "0px" };

  useEffect(() => {
    if (isActive) {
      showLoading();
      cargarCompania();
      cargarConfiguracionEmail();
    }
    return () => {
      cerrarAlertas();
      hideLoading();
    };
  }, [isActive]);


  useEffect(() => {
    if (compania) {
      if (compania.TipoIntegracion == 3) {
        setCompania({ ...compania, UsaSistemaExterno: true });
        setconfiguracionSistemaExterno({
          ...configuracionSistemaExterno,
          Tipo: TIPO_SISTEMA_EXTERNO.QUICKBOOKS,
        });

      }
    }
    return () => {
      cerrarAlertas();
      hideLoading();
    };
  }, [compania?.TipoIntegracion]);

  const grabar = () => {
    showLoading();
    CompaniaManager.actualizar(compania)
      .then(() => {
        Message({ message: `Actualizado Exitosamente` });
        cargarCompania();

      })
      .catch((e) => handleException(e))
      .finally(() => hideLoading());
  };

  const setDefaultTipo = () => {
    setTipoActual(ConfiguracionEmailHelper.TIPO_SERVIDOR_CORREO_DEFAULT);
    setConfiguracionEmail({
      ...configuracionEmail,
      Tipo: ConfiguracionEmailHelper.TIPO_SERVIDOR_CORREO_DEFAULT,
    });
  };

  const cargarCompania = () => {
    CompaniaManager.buscarPorId(usuario.CompaniaId)
      .then((data) => {
        data.Color1 = "#" + data.Color1;
        data.Color2 = "#" + data.Color2;
        data.Color3 = "#" + data.Color3;
        console.log("cargar compania: ", data);
        setCompania(data);
      })
      .finally(() => {
        hideLoading();
      });
  };

  const onFileChange = (propFile, propName) => {
    setCompania({ ...compania, [propName]: propFile });
  };

  const setCheckedProp = (e) => {
    const { name, checked } = e.target;
    setCompania({
      ...compania,
      [name]: checked,
    });
  };

  const cargarConfiguracionEmail = () => {
    showLoading();
    const code = ConfiguracionEmailHelper.obtenerCodigoAutorizacion();
    ConfiguracionCorreoElectronicoManager.buscarMailConfig({
      fuente: ConfiguracionEmailHelper.FUENTE_ENTIDAD.COMPANIA,
      referencia: usuario.CompaniaId,
    })
      .then((data) => {
        if (code) {
          data = {
            ...data,
            Tipo: ConfiguracionEmailHelper.TIPO_SERVIDOR_CORREO.OUTLOOK,
          };
        } else if (data.Tipo === ConfiguracionEmailHelper.TIPO_SERVIDOR_CORREO.SENDGRID) {
          data = {
            ...data,
            Tipo: ConfiguracionEmailHelper.TIPO_SERVIDOR_CORREO.SENDGRID,
          };
        }
        if (!data.Tipo) {
          data = {
            ...data,
            Tipo: ConfiguracionEmailHelper.TIPO_SERVIDOR_CORREO_DEFAULT,
          };
        }
        setConfiguracionEmail(data);
        setTipoActual(data.Tipo);
      })
      .catch((e) => {
        handleException(e);
      })
      .finally(() => {
        hideLoading();
      });
  };

  return isActive ? (
    <Form
      action=""
      className="form-horizontal p-3"
      id="TypeValidation"
      method=""
      autoComplete="off"
    >
      <div
        className="p-0 m-0"
        style={{
          display: "flex",
          flexDirection: "column",
          height: "calc(78vh - 1px)",
        }}
      >
        <Tab.Container
          id="configurar-compania-tabs"
          defaultActiveKey="info-compania"
          activeKey={currentTab}
          onSelect={(eventKey) => setCurrentTab(eventKey)}
        >
          <div
            style={{
              flexShrink: 0,
              backgroundColor: "#fff",
              zIndex: 200,
            }}
          >
            <EditHeader
              titulo="Configuración Compañía"
              grabar={grabar}
              showLoading={showLoading}
              hideLoading={hideLoading}
              isInSimpleBar={true}
            />
            <Nav
              className="ml-0"
              role="tablist"
              variant="tabs"
              fill
              style={{ backgroundColor: "#fff" }}
            >
              <Nav.Item>
                <Nav.Link eventKey="info-compania" style={navStyle}>
                  <SvgComponent iconName="company" fill={iconColor} style={iconStyle} />
                  Información de Compañía
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="rep-impresa" style={navStyle}>
                  <SvgComponent iconName="print" fill={iconColor} style={iconStyle} />
                  Representación Impresa
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="comp-elect" style={navStyle}>
                  <SvgComponent iconName="transaction" fill={iconColor} style={iconStyle} />
                  Comprobantes Electrónicos
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="servidor-correo" style={navStyle}>
                  <SvgComponent iconName="email" fill={iconColor} style={iconStyle} />
                  Servidor de Correo
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="otras-config" style={navStyle}>
                  <SvgComponent iconName="configuration" fill={iconColor} style={iconStyle} />
                  Otras Configuraciones
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <Tab.Content style={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
            <Tab.Pane eventKey="info-compania" style={paneStyle}>
              <InformacionCompaniaTab
                compania={compania}
                setCompania={setCompania}
                onFileChange={onFileChange}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="rep-impresa" style={paneStyle}>
              <RepresentacionImpresaTab
                compania={compania}
                setCompania={setCompania}
                setCheckedProp={setCheckedProp}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="comp-elect" style={paneStyle}>
              <ComprobantesElectronicosTab
                compania={compania}
                setCompania={setCompania}
                setCheckedProp={setCheckedProp}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="servidor-correo" style={paneStyle}>
              <ServidorCorreoTab
                compania={compania}
                setCompania={setCompania}
                setCheckedProp={setCheckedProp}
                configuracionEmail={configuracionEmail}
                setConfiguracionEmail={setConfiguracionEmail}
                tipoActual={tipoActual}
                setTipoActual={setTipoActual}
                setDefaultTipo={setDefaultTipo}
                showLoading={showLoading}
                hideLoading={hideLoading}
                usuario={usuario}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="otras-config" style={paneStyle}>
              <OtrasConfiguracionesTab
                compania={compania}
                setCompania={setCompania}
                setCheckedProp={setCheckedProp}
                onFileChange={onFileChange}
                configuracionSistemaExterno={configuracionSistemaExterno}
                setconfiguracionSistemaExterno={setconfiguracionSistemaExterno}
                configuration={configuration}
                usuario={usuario}
                AMBIENTE_LIST={AMBIENTE_LIST}
                showLoading={showLoading}
                hideLoading={hideLoading}
              />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </Form>
  ) : (
    <></>
  );
}
